var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 32.25V42.75C40 51.5 36.5 55 27.75 55H17.25C8.5 55 5 51.5 5 42.75V32.25C5 23.5 8.5 20 17.25 20H27.75C36.5 20 40 23.5 40 32.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7495 5H32.2495C23.6244 5 20.1244 8.425 20.0244 16.875H27.7495C38.2495 16.875 43.1245 21.75 43.1245 32.25V39.975C51.5745 39.875 54.9995 36.375 54.9995 27.75V17.25C54.9995 8.5 51.4995 5 42.7495 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.e69ea6b857a08085d5959e15f157b609.svg";
export { ForwardRef as ReactComponent };